export type Annotation = {
    label: string;
    x: number;
    y: number;
    size: number;
    type: "triangle" | "dot" | "square" | "text";
    color?: string;
    rotation: number;
    text?: string;
    textColor?: string;
};

// export function parseAnnotations(input: string): Annotation[] {
//     const regex = /\(([^@]+)@([0-9]+(?:\.[0-9]+)?),([0-9]+(?:\.[0-9]+)?); size:([0-9]+(?:\.[0-9]+)?); type=(triangle|dot|square|text);(?: color=([a-zA-Z]+|#(?:[0-9a-fA-F]{3,6}));)?(?: text=([^;]+);?)?(?: text-color=([a-zA-Z]+|#(?:[0-9a-fA-F]{3,6});?)?)? rot=([0-9]+(?:\.[0-9]+)?)\)/g;
//     const result: Annotation[] = [];
//     let match;
//     while ((match = regex.exec(input)) !== null) {
//         const type = match[5] as "triangle" | "dot" | "square" | "text";
//         result.push({
//             label: match[1],
//             x: parseFloat(match[2]),
//             y: parseFloat(match[3]),
//             size: parseFloat(match[4]),
//             type,
//             color: match[6],
//             text: type === "text" ? (match[7] || match[1]) : undefined,
//             textColor: match[8],
//             rot: parseFloat(match[9]),
//         });
//     }
//     return result;
// }

// export function parseAnnotations(input: string): Annotation[] {
//     let annotations = input.split(/\)\s*\(/);
//     annotations[0] = annotations[0].trim().substring(1); // Remove leading '(' from the first annotation
//     annotations[annotations.length - 1] = annotations[annotations.length - 1].trim().substring(0, annotations[annotations.length - 1].length - 1); // Remove trailing ')' from the last annotation
//     let result: Annotation[] = [];
//     for (let i = 0; i < annotations.length; i++) {
//         try {
//             let properties = annotations[i].split(/(?<!\\);/);
//             let annotation: Partial<Annotation> = {};
//             for (let j = 0; j < properties.length; j++) {
//                 let propertyParts: string[];
//                 properties[j] = properties[j].trim().replace(/\\;/g, ";"); // Unescape semicolons
//                 if (j === properties.length - 1 && properties[j] == "") {
//                     continue; // Skip empty properties at the end
//                 }
//                 if (j == 0) {
//                     propertyParts = properties[j].split(/(?<!\\)@/);
//                     propertyParts = propertyParts.map(part => part.replace(/\\@/g, "@")); // unescape at signs
//                     annotation["label"] = propertyParts[0].trim();
//                     let pos = propertyParts[1].split(/,/);
//                     annotation["x"] = parseFloat(pos[0].trim());
//                     annotation["y"] = parseFloat(pos[1].trim());
//                 }
//                 else {
//                     propertyParts = properties[j].split(/(?<!\\)=/);
//                     propertyParts = propertyParts.map(part => part.replace(/\\=/g, "=")); // unescape equal signs
//                     annotation[propertyParts[0].trim()] =
//                         propertyParts[0].trim() === "size" || propertyParts[0].trim() === "rot"
//                             ? parseFloat(propertyParts[1].trim())
//                             : propertyParts[1].trim();


//                 }
//             }
//             result.push(annotation as Annotation);
//         } catch (error) {
//             console.error(`Error parsing annotation at index ${i}:`, error);
//         }

//     }
//     return result;
// }


export function parseAnnotations(input: string | Annotation[]): Annotation[] {

    let annotations: Annotation[];
    let result: Annotation[] = [];
    try {
        if (typeof input === "string") {
            annotations = JSON.parse(input.trim());
        } else {
            annotations = input;
        }
        for (let i = 0; i < annotations.length; i++) {
            try {
                result.push(annotations[i] as Annotation);
            } catch (error) {
                console.error(`Error parsing annotation at index ${i}:`, error);
            }
        }
    } catch (error) {

    }

    return result;
}